import withTracker from './withTracker';
import Join from '../containers/Join';

const join = {
  path: '/join',
  component: withTracker(Join)
};

export default join;
